import { Box, Button, Paper, Stack, Typography, useMediaQuery } from "@mui/material";
import { IndianCurrency } from "app/utils/helper";

const TransactionSummary = ({
  summary,
  calculateTobePaid,
  isAnyItemChecked,
  onPayNow,
}) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  if (!summary || !Object.keys(summary).length) return null;

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        bgcolor: "primary.50",
        borderRadius: 3,
        marginBottom: isMobile ? 10 : 0,
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
      >
        <Stack direction="row" spacing={4} flexWrap="wrap" useFlexGap>
          <Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontSize: "0.875rem", mb: 0.5 }}
            >
              Total Order
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {IndianCurrency(summary?.t_orderAmount)}
            </Typography>
          </Box>
          <Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontSize: "0.875rem", mb: 0.5 }}
            >
              Discount
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="warning.main">
              {IndianCurrency(
                Number(summary?.t_discountAtpurchage ?? 0) +
                  Number(summary?.t_extraDiscountAmount ?? 0),
              )}
            </Typography>
          </Box>
          <Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontSize: "0.875rem", mb: 0.5 }}
            >
              Net Order Amount
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="secondary">
              {IndianCurrency(summary?.t_netOrderAmount)}
            </Typography>
          </Box>
          <Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontSize: "0.875rem", mb: 0.5 }}
            >
              Paid
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="success.main">
              {IndianCurrency(summary?.t_taxableAmount)}
            </Typography>
          </Box>
          <Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontSize: "0.875rem", mb: 0.5 }}
            >
              Balance
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="error.main">
              {IndianCurrency(summary?.t_balanceAmount)}
            </Typography>
          </Box>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography
            variant="body1"
            fontWeight="600"
            color="primary"
            sx={{ fontSize: "1.15rem" }}
          >
            Selected: {IndianCurrency(calculateTobePaid)}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            disabled={!isAnyItemChecked}
            onClick={onPayNow}
            sx={{ borderRadius: 2, px: 2, py: 1 }}
          >
            Pay Now
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default TransactionSummary;
